import React from "react";
import { CRMCodecEditForm } from "../CRMCodecEditForm/CRMCodecEditForm";
import { CRMSpacingColumn } from "../CRMSpacingColumn/CRMSpacingColumn";
import { CRMTitleSection } from "../CRMTitleSection/CRMTitleSection";
import { ListingSellingProcess5 } from "../../../../domain/codecs/Listing";
import { TListingFull1Editable } from "../../../../domain/codecs/formEditable/ListingEditable";
import { CRMAutosaveIndicatorWrap } from "../CRM/CRMAutosaveIndicatorWrap/CRMAutosaveIndicatorWrap";

type TCRMValuationBookingFormProps = {
    listingForm: TListingFull1Editable;
    onChange: (listingForm: TListingFull1Editable) => void;
};

const HIDDEN_FIELDS = [
    "referral_fee_paid",
    "aventria_reference",
    "sellers_view_on_offers",
    "share_offers_deffered",
    "chain_status",
    "valuation_sent",
    "valuation_sent_deferred",
    "valuation_fetched_at",
    "val_case_id",
    "instructed_date",
    "chase_instruction_deferred",
    "live_date",
    "go_live_on_portals_deferred",
    "viewings_can_be_booked_from",
    "preferred_viewing_times",
    "viewings_conducted_by",
    "introducer_referral_fee_percentage",
    "skip_sail_legal_referral_fee_subtraction",
] as const;

export const CRMValuationBookingForm = (props: TCRMValuationBookingFormProps): JSX.Element => {
    return (
        <CRMSpacingColumn spacing="large">
            <CRMAutosaveIndicatorWrap status={props.listingForm.status}>
                <CRMSpacingColumn spacing="large">
                    <CRMTitleSection>
                        Valuation
                    </CRMTitleSection>
                    <CRMCodecEditForm
                        codec={ListingSellingProcess5}
                        model={props.listingForm.edited}
                        validationErrors={props.listingForm.validationErrors}
                        columns={2}
                        hideFields={[...HIDDEN_FIELDS]}
                        onChange={(edited) => props.onChange({
                            ...props.listingForm,
                            edited: {
                                ...props.listingForm.edited,
                                ...edited,
                            }
                        })}
                    />
                </CRMSpacingColumn>
            </CRMAutosaveIndicatorWrap>
        </CRMSpacingColumn>
    );
};
